
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/labels.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-model-labels-demo-append-label","docs-api-model-labels-demo-label-position","docs-api-model-labels-demo-label-offset","docs-api-model-labels-demo-label-rotate","docs-api-model-labels-demo-label-markup","docs-api-model-labels-demo-label-attrs"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/labels.zh.md?type=demo')
};